import {
  ProgressLocalStorageInterface,
  ProgressMonthData,
  RowDataInterface,
} from "../ReportTypes";
import ProgressDataCard from "./ProgressDataCard";
import ProgressHeaderCard from "./ProgressHeaderCard";

export const DisplayTotalRow = ({
  rowData,
  showFluency,
  stateData,
  cardData,
}: {
  rowData: RowDataInterface;
  showFluency: boolean;
  stateData: ProgressLocalStorageInterface;
  cardData?: ProgressMonthData[];
}) => {
  const acc: number[] = [];
  rowData.cardData.map((item: any) => {
    if (item.month === "Overall") acc.push(0);
    else if (item.data.studentCount === "--") acc.push(0);
    else acc.push(item.data.studentCount);
  });
  return (
    <ul className="class">
      <div className="grid grid-cols-1 pr-[15px] sm:grid-cols-8">
        <ProgressHeaderCard
          dataScope={stateData.scope}
          title={rowData.label}
          meta={rowData.meta}
        />
        <li
          key={rowData.key}
          className={`grid-cols-${cardData?.length} ml-2 border-b-2 sm:col-span-7`}
        >
          <div className={`mt-2 grid grid-flow-col`}>
            {rowData.cardData.map((card) => (
              <ProgressDataCard
                key={
                  rowData.key +
                  card.month +
                  card.data.flu.toString() +
                  card.data.perc.toString()
                }
                title={card.month}
                stats={card?.data}
                showFluency={showFluency}
                isTotal={rowData.label === "Total" ? true : false}
                isOverall={card.month === "Overall"}
                allValuesInRow={acc}
              />
            ))}
          </div>
        </li>
      </div>
    </ul>
  );
};
